import { DialogConfig } from '../shared/types';

export const DIALOG_CONFIG: DialogConfig = {
	touchpointIntent: 'addPaymentDetails',
	dialogId: 'standard-trial-limit-breakers-modal',
	dialogType: 'modal',
};
